module.exports = __webpack_public_path__ + "img/IMG_1185X407-03.e5b755c4.png";